import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-3 flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                黑
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mb-4 max-w-sm text-sm leading-relaxed text-background-300">
              {siteInfo.description}
            </p>
            <p className="font-label text-xs text-background-400">
              {siteInfo.nameEn} · 自 {siteInfo.since} 年起持续追踪
            </p>
          </div>

          <div>
            <h3 className="mb-4 font-label text-xs font-medium uppercase tracking-[0.18em] text-accent-400">
              内容分类
            </h3>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/news?category=${encodeURIComponent(cat.id)}`}
                    className="text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-label text-xs font-medium uppercase tracking-[0.18em] text-accent-400">
              快速导航
            </h3>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 transition-colors hover:text-background-50">
                  首页追踪流
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-sm text-background-300 transition-colors hover:text-background-50">
                  全部追踪
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 transition-colors hover:text-background-50">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-300 transition-colors hover:text-background-50">
                  投递线索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-label text-xs font-medium uppercase tracking-[0.18em] text-accent-400">
              联系编辑部
            </h3>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2.5">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center">
                  <i className="ri-mail-line text-secondary-300" />
                </span>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="break-all text-sm text-background-300 transition-colors hover:text-background-50"
                >
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center">
                  <i className="ri-share-forward-line text-secondary-300" />
                </span>
                <span className="break-all text-sm text-background-300">
                  线索投递：{siteInfo.cooperation}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-400">
            © {year} {siteInfo.name} 编辑部 · 内容均为追踪记录，不代表最终结论
          </p>
          <p className="font-label text-xs text-background-400">
            本站内容仅作信息整理与传播，如涉权利问题请联系编辑部处理
          </p>
        </div>
      </div>
    </footer>
  );
}